module.exports = __webpack_public_path__ + "static/media/cq_visualizza_documento.7d8d50b8.svg";